import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

function SortableItem({
  id,
  children,
}: {
  id: string
  children: React.ReactNode
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      transition: {
        duration: 150, // milliseconds
        easing: "ease",
      },
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: "100%",
  }

  return (
    <div
      className="cursor-grabbing"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}>
      {children}
    </div>
  )
}

export default SortableItem
